import { Component } from '@angular/core'
import {
  MbMyaccountAddressbookBaseComponent
} from '../mb-myaccount-addressbook-base/mb-myaccount-addressbook-base.component'
import {
  MbMyaccountAddressbookConnector
} from '../../../connectors/mb-myaccount-addressbook.connector'
import { MbCheckoutRegions } from '../../../../models'

@Component({
  selector: 'mb-myaccount-addressbook-eu',
  templateUrl: './mb-myaccount-addressbook-eu.component.html',
  styleUrls: ['../mb-myaccount-addressbook-base/mb-myaccount-addressbook-base.component.scss']
})
export class MbMyaccountAddressbookEuComponent extends MbMyaccountAddressbookBaseComponent {

  checkoutRegion = MbCheckoutRegions.EU

  constructor (protected mbMyaccountAddressbookConnector: MbMyaccountAddressbookConnector) {
    super(mbMyaccountAddressbookConnector)
  }
}
